import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TheWorldAwaits from "./sections/TheWorldAwaits";
import GlobalEventCalendar from "./sections/GlobalEventCalendar";
import BespokeConcierge from "./sections/BespokeConcierge";
import OurTrustedPartners from "./sections/OurTrustedPartners";
import TheHubHighlights from "./sections/TheHubHighlights";
import BeginYourJourney from "./sections/BeginYourJourney";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <TheWorldAwaits />
      <GlobalEventCalendar />
      <BespokeConcierge />
      <OurTrustedPartners />
      <TheHubHighlights />
      <BeginYourJourney />
      <Footer />
    </div>;
}